export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${
    monthNames[date.getMonth()]
  } ${date.getDate()} / ${date.getFullYear()}`;
};
